export default __webpack_public_path__ + "static/media/rocket_anim_123.e6992f05.png";